import {
  SET_LIST_CORPORATE_GROUP_DATA,
  SET_LIST_CORPORATE_GROUP_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listCorporateGroup : null,
  listCorporateGroupTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_CORPORATE_GROUP_DATA:
      return {
        ...state,
        loading: false,
        listCorporateGroup: action.listCorporateGroup,
      };

    case SET_LIST_CORPORATE_GROUP_TOTAL:
      return {
        ...state,
        loading: false,
        listCorporateGroupTotal: action.corporateGroupsTotal,
      };

    default:
      return { ...state };
  }
};
